import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet";
import axios from "axios";
import { API_URI } from "../Common/data";

function Contact() {
  const [seo, setSeo] = useState({
    title: "Cine Celebrate - Contact Us",
    metaDescription: "",
    metaKeywords: "",
    ogImage: "",
    ogTitle: "",
    ogDescription: "",
    canonicalUrl: "",
  });

  useEffect(() => {
    axios.get(`${API_URI}/page-seo/contact`).then((res) => {
      if (res.data && res.data.data) setSeo(res.data.data);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
            ? seo.metaTitle
            : "Cine Celebrate - Contact Us"}
        </title>
        <meta
          name="title"
          content={
            seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
              ? seo.metaTitle
              : "Cine Celebrate - Contact Us"
          }
        />
        <meta
          name="description"
          content={
            seo.metaDescription &&
            seo.metaDescription.toLowerCase() !== "test description"
              ? seo.metaDescription
              : "Cine Celebrate - Contact Us"
          }
        />
        <meta
          name="keywords"
          content={
            seo?.metaKeywords && Array.isArray(seo?.metaKeywords)
              ? seo?.metaKeywords.join(", ")
              : "Private Theater, Celebration, Cine Celebrate"
          }
        />
        <link rel="canonical" href={seo?.canonicalUrl} />
        <meta property="og:title" content={seo?.ogTitle} />
        <meta property="og:description" content={seo?.ogDescription} />
        <meta property="og:image" content={seo?.ogImage} />
      </Helmet>
      <Navbar />
      <div className="news-banner news-banner5 news-banner-faq">
        <p>Contact</p>
        <br />
        <h1>Contact Us</h1>
      </div>

      <section className="contact-revamp">
        <div className="contact-revamp__intro">
          <div>
            <p className="contact-revamp__eyebrow">Contact Desk</p>
            <h2>Reach us for bookings, questions, or celebration planning help.</h2>
            <p className="contact-revamp__text">
              We love hearing from you. Whether you want to plan a surprise,
              confirm a booking detail, or figure out the right setup for your
              celebration, our team is here to help quickly and clearly.
            </p>
          </div>

          <div className="contact-revamp__meta">
            <span>Support Window</span>
            <strong>Fast responses across WhatsApp, phone, and email</strong>
          </div>
        </div>

        <div className="contact-revamp__grid">
          <article className="contact-revamp-card">
            <div className="contact-revamp-card__icon">
              <i className="bi bi-envelope-fill" />
            </div>
            <p className="contact-revamp__eyebrow">Email</p>
            <h3>Write to us</h3>
            <p>cinecelebrateglobal@gmail.com</p>
            <a href="mailto:cinecelebrateglobal@gmail.com">Send an email</a>
          </article>

          <article className="contact-revamp-card">
            <div className="contact-revamp-card__icon">
              <i className="bi bi-telephone-fill" />
            </div>
            <p className="contact-revamp__eyebrow">WhatsApp</p>
            <h3>Talk to our team</h3>
            <p>+91-9643055509</p>
            <a
              href="https://wa.me/919643055509"
              target="_blank"
              rel="noreferrer"
            >
              Open WhatsApp
            </a>
          </article>

          <article className="contact-revamp-card">
            <div className="contact-revamp-card__icon">
              <i className="bi bi-geo-alt-fill" />
            </div>
            <p className="contact-revamp__eyebrow">Office</p>
            <h3>Visit our location</h3>
            <p>
              Bungalow No-5, Pandav Nagar, Delhi-92
            </p>
            <a
              href="https://maps.google.com/?q=Cine%20Celebrate%20Laxmi%20Nagar%20Delhi"
              target="_blank"
              rel="noreferrer"
            >
              View on Maps
            </a>
          </article>
        </div>

        <div className="contact-revamp__bottom">
          <div className="contact-revamp__social">
            <p className="contact-revamp__eyebrow">Follow Us</p>
            <h3>Stay close to new themes, setups, and celebration ideas.</h3>
            <div className="contact-revamp__social-links">
              <a
                href="https://www.facebook.com/share/19u3ZeyUhZ/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook" />
              </a>
              <a
                href="https://x.com/CineCelebrate?t=104PP-8SeNJ7nXPxYuV0dA&s=09"
                target="_blank"
                rel="noreferrer"
                aria-label="X"
              >
                <i className="bi bi-twitter-x" />
              </a>
              <a
                href="https://www.instagram.com/cinecelebrate?igsh=b283dXFtM2plcG15"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram" />
              </a>
              <a
                href="https://youtube.com/@cinecelebrate?si=jGadqCXx5Y8ZEvuL"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube" />
              </a>
            </div>
          </div>

          <div className="contact-revamp__map-shell">
            <p className="contact-revamp__eyebrow">Find Us</p>
            <h3>Our celebration space in Delhi</h3>
            <div className="contact-revamp__map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.376537688049!2d77.28392877495628!3d28.61847488471988!2m3!1f0!2f0!2f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce56cb83d1f87%3A0xad8ec4963d0423f7!2sCine%20Celebrate!5e0!3m2!1sen!2sin!4v1759552077752!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Cine Celebrate location"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;
